import styled, { css } from 'styled-components';

export const SquareSection = styled.div`
  gap: ${({ theme }) => theme.spacing.s};
  display: flex;
  justify-content: center;
`;

export const SquareContainer = styled.div(
  ({ theme, backgroundColor }) => css`
    height: ${theme.height.h7};
    width: ${theme.height.h7};
    border-radius: ${theme.radius.s};
    background-color: ${theme.colors[backgroundColor]};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    text-align: center;
  `
);

export const VerticalLine = styled.div`
  background-color: ${({ theme }) => theme.colors.verdigrisDark};
  height: ${({ theme }) => theme.height.h7};
  width: 1px;
`;
